import { orderFormSpace } from '../namespaces/orderFormSpace'

// текущие ссылки для заявок
export enum OrderLink {
  new = '/productorder',
  service = '/serviceorder',
  newCompany = '/company/productorder',
}

const isNewType = (formType: orderFormSpace.FormType) =>
  formType === orderFormSpace.FormType.new ||
  formType === orderFormSpace.FormType.newCompany

export function getOrderLink(
  formType: orderFormSpace.FormType,
  userType: orderFormSpace.UserType | null,
): string {
  if (userType === 'company') {
    return OrderLink.newCompany
  }
  return isNewType(formType) ? OrderLink.new : OrderLink.service
}
